import { render, staticRenderFns } from "./model-manage.vue?vue&type=template&id=f0c24012&scoped=true"
import script from "./model-manage.vue?vue&type=script&lang=js"
export * from "./model-manage.vue?vue&type=script&lang=js"
import style0 from "./model-manage.vue?vue&type=style&index=0&id=f0c24012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c24012",
  null
  
)

export default component.exports